import { useContext } from "react";
import { ReplicateActionContext } from "./ReplicateActionContext";
import replicateDeliveryNote from "./replicateDeliveryNote";

function useReplicate() {
  const { elementId, setShowModal, setLoading } = useContext(ReplicateActionContext);
  return (onSuccess: (newId: number) => void) => {
    setLoading(true);
    replicateDeliveryNote(elementId)
      .then((newDeliveryNoteId: number) => {
        setShowModal(false);
        onSuccess(newDeliveryNoteId);
      })
      .finally(() => setLoading(false));
  };
}

export default useReplicate;
